define('lq/events/actions/executeTimer',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function ExecuteTimer(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ExecuteTimer, EventAction);

    ExecuteTimer.typeName = 'ExecuteTimer';

    ExecuteTimer.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ExecuteTimer.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;
        var dropName = self.eventData.timer;
        var drop = self.piping.dropFactory.findDropByName(dropName);
        if (!drop)
            throw 'Cannot find drop : "' + dropName + '" for execute timer event action.';
        if (typeof drop.startTimer !== 'function')
            throw 'Drop : "' + dropName + '" for execute timer event action is not a timer.';
        drop.startTimer();
        continuation();
    };

    return ExecuteTimer;
});
